// header on scroll will have a white background

const $header = $('header')

let lastScrollTop = 0;
// $(window).scroll(function(event){
//   clearTimeout($.data(this, 'scrollTimer'));

//   let st = $(this).scrollTop();
//   if (st > lastScrollTop){
//     $header.removeClass().addClass('header--transparent')
//   } else {
//     $header.removeClass().addClass('header--transparent')
//   }
//   lastScrollTop = st;

//   $.data(this, 'scrollTimer', setTimeout(function() {
//     $header.removeClass().addClass('header--white')
//   }, 250));
// });
